<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-18 10:27:39
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-02-17 16:18:21
-->
<template>
  <div>
    <header :class="['head-page']">
      <HeadMenu ref="headMenu" :defaultActive="activeMenuIndex" :active="realIndex > (language == 'en' ? 0 : 1)" :class="[realIndex > (language == 'en' ? 0 : 1) ? 'navbar-default' : '']"/>
    </header>
    <div class="swiper index-swiper" id="indexSwiper">
      <div class="swiper-wrapper flex_col">
        <div class="swiper-slide" v-if="language == 'zh'">
          <videoDom />
        </div>
        <div class="swiper-slide">
          <Banner />
        </div>
        <div class="swiper-slide">
          <Introduction :real-index="realIndex" :active-index="language == 'en' ? 1 : 2"/>
        </div>
        <div class="swiper-slide">
          <Hexinchanping :real-index="realIndex" :active-index="language == 'en' ? 2 : 3"/>
        </div>
        <div class="swiper-slide" v-if="language == 'zh'">
          <News :real-index="realIndex" :active-index="4"/>
        </div>
        <div class="swiper-slide">
          <Partner :real-index="realIndex" :active-index="language == 'en' ? 3 : 5"/>
        </div>
        <div class="swiper-slide heiauto">
          <Footer id="footer" class="posrel"/>
        </div>
      </div>
      <div v-show="pagination" :class="['swiper-pagination index-swiper-pagination swiper-pagination-clickable swiper-pagination-bullets', realIndex == 0 || realIndex == 1 ? 'active' : '']"></div>
    </div>
    <div class="ui-swiper-next" v-show="pagination" @click="clickNext">
      <img class="wh100" :src="require('@/assets/images/next.png')" alt="" srcset="">
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeadMenu from '@/components/pc/HeadMenu' // 头部
import Footer from '@/components/pc/Footer' // 头部
import videoDom from './components/video' // 视频播放
import Banner from './components/banner' // 首页轮播
import Introduction from './components/introduction' // 脉流简介
import Hexinchanping from './components/hexinchanping' // 核心产品
import News from './components/news' // 核心产品
import Partner from './components/partner' // 核心产品

export default {
  name: 'Indexpc',
  components: {
    HeadMenu,
    Footer,
    videoDom,
    Banner,
    Introduction,
    Hexinchanping,
    News,
    Partner
  },
  data () {
    return {
      activeMenuIndex: this.$route.meta.checked, // 选中菜单
      realIndex: 0,
      pagination: true,
      translate: 0
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  mounted () {
    const _this = this
    this.mySwiper = new this.$Swiper('#indexSwiper', {
      threshold: 100, // 必须拖动大于100PX后slide才会开始移动
      direction: 'vertical', // 上下
      // mousewheel: true, // 鼠标滚动切换
      mousewheel: {
        releaseOnEdges: true // PC端释放滑动
      },
      speed: 1000,
      slidesPerView: 'auto',
      pagination: {
        el: '.index-swiper-pagination',
        bulletElement: 'li',
        clickable: true
      },
      on: {
        slideChangeTransitionStart: function () {
          _this.realIndex = this.activeIndex
        },
        setTranslate: function (translate) {
          _this.translate = translate
          const len = this.language === 'en' ? 3 : 5
          if (_this.realIndex === len) {
            const height = document.body.clientHeight
            if (-translate / height > len) {
              _this.pagination = false
            } else {
              _this.pagination = true
            }
          }
        }
      }
    })
  },
  methods: {
    clickNext () {
      const realIndex = this.realIndex
      const len = this.language === 'en' ? 3 : 5
      if (realIndex < len) {
        this.mySwiper.slideTo(realIndex + 1, 1000, false)
        this.realIndex = realIndex + 1
      } else {
        const height = document.body.clientHeight
        if (-this.translate / height === len) {
          // const hei = document.getElementById('footer').clientHeight
          // this.mySwiper.translateTo(this.translate - hei, 1000, true, false)
          this.mySwiper.slideTo(realIndex + 1, 1000, false)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.index-swiper {
  height: 100vh;
  width: 100%;
  position: absolute;
  top: 0;
  .swiper-slide {
    width: 100%;
    overflow: hidden;
  }
}
</style>

<style lang="less">
.pc .index-swiper {
  overflow: hidden;
  .index-swiper-pagination {
    right: 46PX;
    .swiper-pagination-bullet {
      width: 10PX;
      height: 10PX;
      background: rgba(0,0,0, 1);
      // opacity: 1;
      margin: 22PX auto;
      // transition: width 0.3s;
      &:last-child {
        display: none;
      }
    }
    .swiper-pagination-bullet-active {
      width: 20PX;
      height: 20PX;
      background: #00A0E9;
      opacity: 1;
    }
    &.active {
      .swiper-pagination-bullet {
        background: rgba( 255, 255, 255, 1);
      }
      .swiper-pagination-bullet-active {
        background: #00A0E9;
      }
    }
  }
}
</style>
